<table border="1" *ngIf="full">
    <tr *ngFor="let field of full | keyvalue:defaultOrder; let i = index"
        class="{{ i % 2 == 0 ? 'even' : 'odd' }}"
        [ngSwitch]="field.value.type"
    >
        <td>
            {{ field.value.name }}
        </td>
        <td>
<!--            <ng-container *ngSwitchDefault>-->
<!--                <input [(ngModel)]="data[field.key]" placeholder="{{ field.value.name }}">-->
<!--            </ng-container>-->

            <select *ngSwitchCase="'enum'" (change)="changeSelect(field.key, $event.target.value)" value="0">
                <option *ngFor="let item of field.value.enum | keyvalue:defaultOrder"
                        [value]="item.key">{{ item.value }}</option>
            </select>
            <ng-container *ngSwitchCase="'file:Image'">
                <input type="file" (change)="fileChanged(field.key, data, $event.target.files)">
            </ng-container>
            <textarea *ngSwitchCase="'text'" [(ngModel)]="data[field.key]" placeholder="{{ field.value.name }}" rows="3"></textarea>
            <div *ngSwitchCase="'datetime'" style="display: flex; justify-content: space-between">
                <input [(ngModel)]="data[field.key]" placeholder="{{ field.value.name }}">
                <button [(datePicker)]="data[field.key]">
                    <i class="fas fa-calendar-day"></i>
                </button>
            </div>
            <div *ngSwitchDefault style="display: flex; justify-content: space-between">
                <input [(ngModel)]="data[field.key]" placeholder="{{ field.value.name }}">
                <button *ngIf="DATA.isRelation(field.value.type)"
                        (click)="showRelationTable(field.value.type, field.key, data)">
                    <i class="fas fa-th-list"></i>
                </button>
            </div>
        </td>
    </tr>
</table>

<button class="button" (click)="create()">Создать</button>

<app-relation [table]="relation_model" (onChangeId)="onChangeId($event)" (onClose)="showRelation = false"
              *ngIf="showRelation"></app-relation>
